import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import useDynamicColors from "../../hooks/useDynamicColors";
import "./style.css";

const TimelineStep = ({ title, date }) => {
  const colors = useDynamicColors();

  const styles = {
    container: {
      fontFamily: "Inter",
      fontSize: "14px",
      display: "flex",
      height: "100vh",
      backgroundColor: "#f7f9fc",
    },
    screen: {
      backgroundColor: "white",
      borderRadius: "5px",
      overflowY: "scroll",
      overflowX: "hidden",
      width: "100%",
      height: "500px",
    },
    base: {
      position: "absolute",
      width: "1100px",
      height: "20px",
      backgroundColor: "rgb(170, 170, 170)",
      borderRadius: "0px 0px 10px 10px",
      bottom: 0,
    },
    laptop: {
      marginTop: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#333",
      borderRadius: "15px 15px 5px 5px",
      padding: "10px",
      width: "960px",
      height: "500px",
      position: "relative",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    },
    header: {
      display: "flex",
      padding: "20px",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    },
    title: {
      fontSize: "1.5em",
      color: "rgb(1, 8, 122)",
      fontWeight: 700,
    },
    navLinkStyle: {
      display: "flex",
      alignItems: "center",
      padding: "10px",
      color: colors.primario,
      textDecoration: "none",
      borderRadius: "5px",
      fontSize: "0.8em",
      fontWeight: "200",
      gap: "10px",
    },
    disableButton: {
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "10px 20px",
      borderRadius: "4px",
      cursor: "pointer",
    },
    tabList: {
      display: "flex",
      borderBottom: "2px solid blue",
      justifyContent: "space-around",
      backgroundColor: "#f5f5f5",
      padding: "10px 0",
    },
    tab: {
      fontWeight: "bold",
      color: colors.primario,
      cursor: "pointer",
    },
    tabSelected: {
      color: colors.secundario,
      borderBottom: "3px solid #0000ff",
    },
    infoGrid: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    card: {
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "30px",
    },
    personalInfo: {
      display: "flex",
      alignItems: "center",
      gridColumn: "span 2",
    },
    profileImg: {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
    },
    info: {
      margin: 0,
      fontSize: "1.4em",
    },
    approvedStatus: {
      marginTop: 20,
      backgroundColor: "rgb(0, 194, 40)",
      padding: "4px 6px",
      color: "#ffffff",
      borderColor: "rgb(0, 194, 40)",
      borderWidth: "0px",
      borderStyle: "solid",
      borderRadius: "8px",
      textAlign: "center",
      fontSize: "12px",
    },
    icon: {
      width: "60px",
      height: "60px",
    },
    timeline: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    timelineItem: {
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 0",
      borderBottom: "1px solid #e0e0e0",
    },
    boldText: {
      fontWeight: "bold",
    },
    onboardingTimeline: {
      padding: "20px",
      borderRadius: "8px",

      backgroundColor: "#fff",
      width: "400px",
      maxWidth: "400px",
    },
    timelineTable: {
      width: "100%",
      marginTop: "5px",
    },
    timelineRow: {
      width: "100%",
    },
    timelineCell: {
      position: "relative",
      width: "100%",
    },
    timelineContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
    },
    timelineIconContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginRight: "10px",
    },
    timelineIcon: {
      width: "30px",
      height: "30px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    timelineConnector: {
      width: "2px",
      height: "100%",
      backgroundColor: colors.secundario,
      marginTop: "4px",
    },
    timelineContent: {
      display: "flex",
      flexDirection: "column",
    },
    timelineTitle: {
      fontSize: "12px",
      fontWeight: 300,
      color: colors.secundario,
    },
    timelineDate: {
      fontSize: "10px",
      marginTop: 10,
      color: "#555",
    },
  };
  <tr style={styles.timelineRow}>
    <td style={styles.timelineCell}>
      <div style={styles.timelineContainer}>
        <div style={styles.timelineIconContainer}>
          <div style={styles.timelineIcon}>
            {/* SVG del ícono de check */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="20"
                height="20"
                fill={colors.secundario}
            >
              <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
            </svg>
          </div>
          <div style={styles.timelineConnector}></div>
        </div>
        <div style={styles.timelineContent}>
          <span style={styles.timelineTitle}>{title}</span>
          <span style={styles.timelineDate}>{date}</span>
        </div>
      </div>
    </td>
  </tr>;
};

export const UserDetailsDashboard = () => {
  const colors = useDynamicColors();

  const styles = {
    container: {
      fontFamily: "Inter",
      fontSize: "14px",
      display: "flex",
      height: "100vh",
      backgroundColor: "#f7f9fc",
    },
    screen: {
      backgroundColor: "white",
      borderRadius: "5px",
      overflowY: "scroll",
      overflowX: "hidden",
      width: "100%",
      height: "500px",
    },
    base: {
      position: "absolute",
      width: "1100px",
      height: "20px",
      backgroundColor: "rgb(170, 170, 170)",
      borderRadius: "0px 0px 10px 10px",
      bottom: 0,
    },
    laptop: {
      marginTop: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#333",
      borderRadius: "15px 15px 5px 5px",
      padding: "10px",
      width: "960px",
      height: "500px",
      position: "relative",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    },
    header: {
      display: "flex",
      padding: "20px",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    },
    title: {
      fontSize: "1.5em",
      color: colors.primario,
      fontWeight: 700,
    },
    navLinkStyle: {
      display: "flex",
      alignItems: "center",
      padding: "10px",
      color: colors.primario,
      textDecoration: "none",
      borderRadius: "5px",
      fontSize: "0.8em",
      fontWeight: "200",
      gap: "10px",
    },
    disableButton: {
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "10px 20px",
      borderRadius: "4px",
      cursor: "pointer",
    },
    tabList: {
      display: "flex",
      borderBottom: "2px solid blue",
      justifyContent: "space-around",
      backgroundColor: "#f5f5f5",
      padding: "10px 0",
    },
    tab: {
      fontWeight: "bold",
      color: colors.primario,
      cursor: "pointer",
    },
    tabSelected: {
      color: colors.primario,
      borderBottom: "3px solid #0000ff",
    },
    infoGrid: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    card: {
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "30px",
    },
    personalInfo: {
      display: "flex",
      alignItems: "center",
      gridColumn: "span 2",
    },
    profileImg: {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
    },
    info: {
      margin: 0,
      fontSize: "1.4em",
    },
    approvedStatus: {
      marginTop: 20,
      backgroundColor: "rgb(0, 194, 40)",
      padding: "4px 6px",
      color: "#ffffff",
      borderColor: "rgb(0, 194, 40)",
      borderWidth: "0px",
      borderStyle: "solid",
      borderRadius: "8px",
      textAlign: "center",
      fontSize: "12px",
    },
    icon: {
      width: "60px",
      height: "60px",
    },
    timeline: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    timelineItem: {
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 0",
      borderBottom: "1px solid #e0e0e0",
    },
    boldText: {
      fontWeight: "bold",
    },
    onboardingTimeline: {
      padding: "20px",
      borderRadius: "8px",

      backgroundColor: "#fff",
      width: "400px",
      maxWidth: "400px",
    },
    timelineTable: {
      width: "100%",
      marginTop: "5px",
    },
    timelineRow: {
      width: "100%",
    },
    timelineCell: {
      position: "relative",
      width: "100%",
    },
    timelineContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
    },
    timelineIconContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginRight: "10px",
    },
    timelineIcon: {
      width: "30px",
      height: "30px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    timelineConnector: {
      width: "2px",
      height: "100%",
      backgroundColor: colors.secundario,
      marginTop: "4px",
    },
    timelineContent: {
      display: "flex",
      flexDirection: "column",
    },
    timelineTitle: {
      fontSize: "12px",
      fontWeight: 300,
      color: colors.secundario,
    },
    timelineDate: {
      fontSize: "10px",
      marginTop: 10,
      color: "#555",
    },
  };

  const steps = [
    { title: "Terms & Conditions Acceptance", date: "2024-11-06 18:16:54" },
    { title: "Email Record", date: "2024-11-06 18:17:29" },
    { title: "ID Record", date: "2024-11-06 18:19:14" },
    { title: "Self Alive", date: "2024-11-06 18:19:49" },
    { title: "SMS Record", date: "2024-11-06 18:22:10" },
    { title: "Credentials generation", date: "2024-11-06 18:22:44" },
  ];

  return (
      <div style={styles.laptop}>
        <div style={styles.screen}>
          <div style={styles.container}>
            <div style={{ fontFamily: "Inter" }}>
              {/* Navbar */}
              <div
                  style={{
                    width: "150px",
                    backgroundColor: "#E0E0E0",
                    padding: "20px",
                    height: "100vh",
                    boxSizing: "border-box",
                  }}
              >
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <img
                      src={
                          colors.url_logo ??
                          "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png"
                      }
                      alt="Logo"
                      style={{ width: "60px", marginBottom: "10px" }}
                  />

                  <p
                      style={{
                        color: colors.primario,
                        fontSize: "0.8em",
                        fontWeight: "300",
                        marginTop: 10,
                      }}
                  >
                    It's nice to see u!
                  </p>
                </div>
                <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                >
                  <a href={`/backoffice-users-corporativo-web${location.search}`} style={styles.navLinkStyle}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        width={20}
                        height={20}
                        fill={colors.secundario}
                    >
                      <path
                          d="M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"
                          fill={colors.secundario}
                      ></path>
                    </svg>
                    Users
                  </a>
                  <a href="#" style={styles.navLinkStyle}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width={20}
                        height={20}
                        fill={colors.secundario}
                    >
                      <path
                          d="M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
                          fill={colors.secundario}
                      ></path>
                    </svg>
                    Merchants
                  </a>
                  <a href="#" style={styles.navLinkStyle}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width={20}
                        height={20}
                        fill={colors.secundario}
                    >
                      <path
                          d="M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z"
                          fill={colors.secundario}
                      ></path>
                    </svg>
                    Banners
                  </a>
                  <a href="#" style={styles.navLinkStyle}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                        width={20}
                        height={20}
                        fill={colors.secundario}
                    >
                      <path
                          d="M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"
                          fill={colors.secundario}
                      ></path>
                    </svg>
                    Campaigns
                  </a>
                  <a href="#" style={styles.navLinkStyle}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width={20}
                        height={20}
                        fill={colors.secundario}
                    >
                      <path
                          d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                          fill={colors.secundario}
                      ></path>
                    </svg>
                    Audits
                  </a>
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: colors.primario,
                    color: "white",
                    padding: "15px",
                    // marginLeft: -20,
                    marginRight: -20,
                    // marginTop: -20,
                    // borderRadius: "8px 8px 0 0",
                  }}
              >
                <h1 style={{ fontSize: "1em", fontWeight: "bold" }}>
                  Dashboard Administrator
                </h1>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                  >
                    <p style={{ marginRight: "20px" }}>User</p>
                    <p style={{ marginRight: "20px" }}>Admin</p>
                  </div>
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width={20}
                      height={20}
                      fill="#FFFFFF"
                  >
                    <path
                        d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width={20}
                        height={20}
                        fill="#FFFFFF"
                    ></path>
                  </svg>
                  <div style={{ marginLeft: 15 }}>
                    <path
                        d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                        fill="#FFFFFF"
                    ></path>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width={20}
                        height={20}
                        fill="#FFFFFF"
                    >
                      <path
                          d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                          fill="#FFFFFF"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <Tabs style={{ fontWeight: 300 }}>
                <div
                    style={{
                      fontWeight: 700,
                      fontSize: 12,
                      paddingTop: 40,
                      paddingLeft: 20,
                      marginBottom: 10,
                    }}
                >
                  <span style={{ color: colors.secundario }}>Users / </span>{" "}
                  <span style={{ color: colors.primario }}>
                 Jhon Doe
                </span>
                </div>

                <TabList>
                  <Tab>Onboarding</Tab>
                  <Tab>Accounts</Tab>
                  <Tab>Scores</Tab>
                  <Tab>Transactions</Tab>
                  <Tab>Trades</Tab>
                  <Tab>Digital Folder</Tab>
                </TabList>

                <TabPanel>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ ...styles.header, width: "100%" }}>
                      <p style={styles.title}>Customer Detail</p>
                      <button style={styles.disableButton}>
                        Disable Account
                      </button>
                    </div>
                    <div style={{ display: "flex", gap: 12, padding: 20 }}>
                      <div style={{ width: "50%" }}>
                        <section style={styles.infoGrid}>
                          {/* Personal Information */}
                          <div style={{ ...styles.card, ...styles.personalInfo }}>
                            <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                            >
                              <img
                                  src="/img/frame-480954771-5.png"
                                  alt="Customer Profile"
                                  style={styles.profileImg}
                              />
                              <div style={styles.approvedStatus}>Approved</div>
                            </div>
                            <div style={{ marginLeft: 20 }}>
                              <h3 style={{ fontWeight: 700, marginBottom: 5 }}>
                                <strong>Ana Juliana Fer Hurtado</strong>
                              </h3>
                              <p style={{ fontSize: 12, marginBottom: 3 }}>
                                Id: 4556789
                              </p>
                              <p style={{ fontSize: 12, marginBottom: 3 }}>
                                Email: test@gmail.com
                              </p>
                              <p style={{ fontSize: 12, marginBottom: 3 }}>
                                Phone: 456890907
                              </p>
                              <p style={{ fontSize: 12, marginBottom: 3 }}>
                                Address: Av buenos Aires.
                              </p>
                              <p style={{ fontSize: 12, marginBottom: 3 }}>
                                Gender: Female
                              </p>
                              <p style={{ fontSize: 12, marginBottom: 3 }}>
                                Birth Date: 03/06/1987
                              </p>
                              <div style={{ display: "flex", gap: 8 }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                    width={20}
                                    height={20}
                                    fill={colors.primario}
                                >
                                  <path
                                      d="M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
                                      fill={colors.primario}
                                  ></path>
                                </svg>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                    width={20}
                                    height={20}
                                    fill={colors.primario}
                                >
                                  <path
                                      d="M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
                                      fill={colors.primario}
                                  ></path>
                                </svg>
                              </div>
                            </div>
                          </div>

                          {/* Gamification */}
                          <div style={styles.card}>
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "30%" }}>
                                <svg
                                    width={50}
                                    height={50}
                                    viewBox="0 0 151 150"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                      cx={104.5}
                                      cy={103}
                                      r={26}
                                      fill="#5ECAFA"
                                  />
                                  <path
                                      d="M85.2617 103.125C85.2617 106.833 86.3614 110.459 88.4217 113.542C90.4819 116.625 93.4103 119.029 96.8364 120.448C100.263 121.867 104.033 122.238 107.67 121.515C111.307 120.791 114.648 119.005 117.27 116.383C119.892 113.761 121.678 110.42 122.401 106.783C123.125 103.146 122.754 99.3758 121.334 95.9497C119.915 92.5236 117.512 89.5952 114.429 87.5349C111.345 85.4747 107.72 84.375 104.012 84.375C99.0389 84.375 94.2698 86.3504 90.7535 89.8668C87.2372 93.3831 85.2617 98.1522 85.2617 103.125ZM104.012 89.0625C106.793 89.0625 109.512 89.8872 111.824 91.4325C114.137 92.9777 115.939 95.1739 117.004 97.7435C118.068 100.313 118.347 103.141 117.804 105.868C117.261 108.596 115.922 111.102 113.955 113.069C111.989 115.035 109.483 116.375 106.755 116.917C104.027 117.46 101.2 117.181 98.6302 116.117C96.0606 115.053 93.8644 113.25 92.3192 110.938C90.774 108.625 89.9492 105.906 89.9492 103.125C89.9492 99.3954 91.4308 95.8185 94.068 93.1813C96.7053 90.5441 100.282 89.0625 104.012 89.0625Z"
                                      fill={colors.primario}
                                  />
                                  <path
                                      d="M100.109 109.207C100.327 109.425 100.586 109.598 100.87 109.716C101.155 109.834 101.46 109.894 101.768 109.894C102.076 109.894 102.381 109.834 102.665 109.716C102.95 109.598 103.208 109.425 103.426 109.207L112.262 100.359C112.497 100.147 112.687 99.8882 112.82 99.5998C112.953 99.3114 113.026 98.9991 113.034 98.6817C113.042 98.3643 112.986 98.0485 112.869 97.7535C112.752 97.4585 112.575 97.1904 112.351 96.9655C112.127 96.7406 111.86 96.5636 111.565 96.4452C111.271 96.3268 110.955 96.2695 110.638 96.2767C110.32 96.284 110.008 96.3556 109.719 96.4874C109.43 96.6191 109.171 96.8081 108.957 97.043L101.774 104.227L98.2579 100.711C98.0443 100.476 97.7852 100.287 97.4963 100.155C97.2075 100.024 96.8948 99.952 96.5774 99.9447C96.26 99.9375 95.9445 99.9948 95.6499 100.113C95.3553 100.232 95.0878 100.409 94.8637 100.633C94.6396 100.858 94.4635 101.126 94.3462 101.421C94.2288 101.716 94.1726 102.032 94.181 102.35C94.1894 102.667 94.2621 102.979 94.3949 103.268C94.5276 103.556 94.7176 103.815 94.9532 104.027L100.109 109.207Z"
                                      fill={colors.primario}
                                  />
                                  <path
                                      d="M101.781 46.0312H106.469C107.09 46.0312 107.686 46.2782 108.126 46.7177C108.566 47.1573 108.812 47.7534 108.812 48.375H113.5C113.5 46.5102 112.759 44.7218 111.441 43.4032C110.122 42.0845 108.334 41.3438 106.469 41.3438V39H101.781V41.3438C99.9164 41.3438 98.128 42.0845 96.8094 43.4032C95.4908 44.7218 94.75 46.5102 94.75 48.375C94.75 50.2398 95.4908 52.0282 96.8094 53.3468C98.128 54.6655 99.9164 55.4062 101.781 55.4062H106.469C107.09 55.4062 107.686 55.6532 108.126 56.0927C108.566 56.5323 108.812 57.1284 108.812 57.75C108.812 58.3716 108.566 58.9677 108.126 59.4073C107.686 59.8468 107.09 60.0938 106.469 60.0938H101.781C101.16 60.0938 100.564 59.8468 100.124 59.4073C99.6844 58.9677 99.4375 58.3716 99.4375 57.75H94.75C94.75 59.6148 95.4908 61.4032 96.8094 62.7218C98.128 64.0405 99.9164 64.7812 101.781 64.7812V67.125H106.469V64.7812C108.334 64.7812 110.122 64.0405 111.441 62.7218C112.759 61.4032 113.5 59.6148 113.5 57.75C113.5 55.8852 112.759 54.0968 111.441 52.7782C110.122 51.4595 108.334 50.7188 106.469 50.7188H101.781C101.16 50.7188 100.564 50.4718 100.124 50.0323C99.6844 49.5927 99.4375 48.9966 99.4375 48.375C99.4375 47.7534 99.6844 47.1573 100.124 46.7177C100.564 46.2782 101.16 46.0312 101.781 46.0312Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M129.406 14.0625H77.8438C75.9789 14.0625 74.1905 14.8033 72.8719 16.1219C71.5533 17.4405 70.8125 19.2289 70.8125 21.0938V71.4844C70.8125 72.106 71.0594 72.7021 71.499 73.1417C71.9385 73.5812 72.5346 73.8281 73.1562 73.8281C73.7779 73.8281 74.374 73.5812 74.8135 73.1417C75.2531 72.7021 75.5 72.106 75.5 71.4844V21.0938C75.5 20.4721 75.7469 19.876 76.1865 19.4365C76.626 18.9969 77.2221 18.75 77.8438 18.75H88.3906V21.0938C88.3906 22.9586 89.1314 24.747 90.45 26.0656C91.7686 27.3842 93.5571 28.125 95.4219 28.125H111.828C113.693 28.125 115.481 27.3842 116.8 26.0656C118.119 24.747 118.859 22.9586 118.859 21.0938V18.75H129.406C130.028 18.75 130.624 18.9969 131.064 19.4365C131.503 19.876 131.75 20.4721 131.75 21.0938V128.906C131.75 129.528 131.503 130.124 131.064 130.564C130.624 131.003 130.028 131.25 129.406 131.25H77.8438C77.2221 131.25 76.626 131.003 76.1865 130.564C75.7469 130.124 75.5 129.528 75.5 128.906V120.703C75.5 120.082 75.2531 119.485 74.8135 119.046C74.374 118.606 73.7779 118.359 73.1562 118.359C72.5346 118.359 71.9385 118.606 71.499 119.046C71.0594 119.485 70.8125 120.082 70.8125 120.703V128.906C70.8125 130.771 71.5533 132.559 72.8719 133.878C74.1905 135.197 75.9789 135.938 77.8438 135.938H129.406C131.271 135.938 133.059 135.197 134.378 133.878C135.697 132.559 136.438 130.771 136.438 128.906V21.0938C136.438 19.2289 135.697 17.4405 134.378 16.1219C133.059 14.8033 131.271 14.0625 129.406 14.0625ZM114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z"
                                      fill="#9F0DFF"
                                  />
                                  <path
                                      d="M33 54L18.5253 39.4632C17.1582 38.0903 17.1582 35.8895 18.5253 34.5368L33 20L47.4747 34.5368C48.8418 35.9097 48.8418 38.1104 47.4747 39.4632L33 54Z"
                                      fill="#9F0DFF"
                                  />
                                  <path
                                      d="M75.1952 104.566C76.616 101.634 77.8223 98.6027 78.8046 95.496C79.2688 94.2563 79.4446 92.9272 79.3187 91.6095C79.1928 90.2917 78.7685 89.0199 78.078 87.8906C76.5143 85.3469 74.1161 83.425 71.2929 82.4531C71.2929 77.9062 67.203 74.8476 63.0897 72.9609C62.6754 71.2893 61.8802 69.7362 60.7662 68.4229C59.6521 67.1097 58.2495 66.0718 56.6679 65.3906C59.6561 58.2304 63.1952 49.3359 64.2499 45.5741C66.0077 39.3046 67.9764 32.9882 61.2733 30.4921C55.0155 28.1484 51.2186 35.6132 49.3788 39.1757C40.4608 56.5781 35.3163 64.7226 35.3163 64.8398C33.2304 68.2148 32.7499 68.8593 32.0585 69.0116C30.6305 66.9536 29.4097 64.7593 28.4139 62.4609C24.6874 54.8085 20.2108 51.914 15.1014 53.8124C8.97254 56.121 7.53113 62.2968 10.4257 68.4609C14.4804 77.1679 14.0116 88.6171 13.0155 98.0859C12.4061 104.086 13.8944 108.797 17.4686 112.148C17.2487 113.265 16.9271 114.36 16.5077 115.418C16.362 115.794 16.3157 116.201 16.3734 116.6C16.4312 116.999 16.5909 117.377 16.8371 117.696C17.0834 118.015 17.4079 118.266 17.7792 118.423C18.1506 118.58 18.5562 118.639 18.9569 118.594C24.1344 118.222 29.3311 118.974 34.1913 120.797C40.1103 123.25 45.5283 126.769 50.1757 131.18C50.4142 131.413 50.6999 131.593 51.0136 131.707C51.3273 131.822 51.6617 131.867 51.9946 131.842C52.3274 131.816 52.651 131.72 52.9436 131.559C53.2362 131.399 53.4911 131.177 53.6913 130.91C57.91 125.051 55.9179 127.066 58.871 124.512C66.1014 118.254 70.953 113.226 75.1366 104.59L75.1952 104.566ZM74.0233 90.2929C74.3695 90.8462 74.5779 91.4744 74.6309 92.1249C74.6839 92.7754 74.5801 93.4292 74.328 94.0312C73.417 96.9027 72.3048 99.7065 70.9999 102.422C70.5899 103.01 69.9863 103.436 69.2944 103.624C68.6026 103.813 67.8665 103.752 67.2147 103.453C66.5652 103.098 66.0089 102.595 65.5913 101.984C65.1738 101.373 64.9068 100.671 64.8124 99.9374C65.7474 98.9128 66.4792 97.7197 66.9686 96.4218C68.328 92.7656 69.5116 90.2812 70.4257 87.2812C71.9007 87.9 73.1546 88.9497 74.0233 90.2929ZM66.4296 81.457C67.0155 82.6288 66.16 85.289 65.5741 87.082C65.1522 88.3827 63.7811 91.4882 62.6093 94.7109C61.953 96.4804 60.5936 98.0976 58.7186 97.8749C57.9519 97.7407 57.2341 97.4068 56.6375 96.9069C56.0409 96.407 55.5865 95.7587 55.3202 95.0273C56.2584 94.1776 56.9814 93.1173 57.4296 91.9335C62.8436 78.3046 62.6093 78.7734 62.8436 78.164C64.3354 78.8872 65.5822 80.0321 66.4296 81.457ZM58.0155 72.7968C59.7968 76.1718 57.3358 78.4452 53.0585 90.2343C52.3554 91.9921 51.2069 92.3788 49.7772 91.6874C48.9803 91.1879 48.3647 90.4459 48.0209 89.5705C47.677 88.6951 47.6231 87.7325 47.8671 86.8241C49.0389 82.8398 53.8436 72.0351 54.7929 69.7968C56.1697 70.4123 57.3032 71.4675 58.0155 72.7968ZM55.8475 120.914C52.6132 123.715 53.5741 122.93 51.4647 125.965C46.8392 121.93 41.5764 118.691 35.8905 116.379C31.4283 114.691 26.7038 113.803 21.9335 113.754C22.7069 110.355 21.6639 109.5 21.1014 109.066C18.3124 106.723 17.1991 103.348 17.6796 98.5898C18.746 88.3945 19.2499 76.1718 14.6796 66.4921C13.0975 63.0937 13.0975 59.5781 16.6483 58.289C17.6561 57.9023 20.3632 56.8945 24.1132 64.5937C25.9647 68.4257 26.0819 68.1093 30.7811 78.996C31.045 79.5379 31.5074 79.9573 32.0724 80.1671C32.6375 80.3769 33.2616 80.361 33.8151 80.1227C34.3687 79.8844 34.8092 79.442 35.0451 78.8873C35.281 78.3327 35.2942 77.7085 35.0819 77.1445C35.0233 76.9921 34.3554 75.457 33.4999 73.5116C35.8436 72.7968 37.0155 70.8632 39.2069 67.3827C39.2772 67.2656 44.5624 58.8398 53.5038 41.4023C56.1639 36.2226 57.9218 34.371 59.5975 34.9687C62.41 36.0234 61.203 38.9882 59.6913 44.3437C58.3202 49.2187 52.203 64.0077 49.3788 70.4648C47.7499 74.2148 44.3983 82.1835 43.3905 85.3945C42.8008 87.3744 42.9112 89.497 43.7031 91.4052C44.4949 93.3133 45.9199 94.8904 47.7382 95.871C48.7243 96.3422 49.7981 96.6017 50.8905 96.6327C51.4565 98.1807 52.4346 99.5447 53.7192 100.577C55.0038 101.61 56.5461 102.272 58.1796 102.492C58.9939 102.593 59.8197 102.545 60.6171 102.351C61.0027 103.508 61.6162 104.576 62.4213 105.492C63.2263 106.408 64.2067 107.153 65.3046 107.684C66.0485 108.014 66.8391 108.228 67.6483 108.316C64.3203 113.044 60.3483 117.285 55.8475 120.914Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M34.4844 33.0938V19.5586C34.4844 18.937 34.2374 18.3409 33.7979 17.9013C33.3584 17.4618 32.7622 17.2148 32.1406 17.2148C31.519 17.2148 30.9229 17.4618 30.4833 17.9013C30.0438 18.3409 29.7969 18.937 29.7969 19.5586V33.0938C29.7969 33.7154 30.0438 34.3115 30.4833 34.751C30.9229 35.1906 31.519 35.4375 32.1406 35.4375C32.7622 35.4375 33.3584 35.1906 33.7979 34.751C34.2374 34.3115 34.4844 33.7154 34.4844 33.0938Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M42.0898 37.8866L50.8905 28.0194C51.0952 27.7886 51.2524 27.5197 51.3532 27.2281C51.4539 26.9365 51.4963 26.6279 51.4778 26.32C51.4593 26.012 51.3803 25.7107 51.2454 25.4333C51.1104 25.1559 50.9222 24.9077 50.6913 24.703C50.4605 24.4984 50.1916 24.3412 49.9 24.2404C49.6084 24.1396 49.2998 24.0973 48.9919 24.1158C48.6839 24.1343 48.3826 24.2133 48.1052 24.3482C47.8277 24.4832 47.5796 24.6714 47.3749 24.9023L38.5859 34.7694C38.1725 35.2356 37.9613 35.847 37.9986 36.4689C38.036 37.0909 38.3189 37.6725 38.7851 38.0859C39.2513 38.4992 39.8626 38.7105 40.4845 38.6731C41.1065 38.6357 41.6881 38.3528 42.1015 37.8866H42.0898Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M25.496 38.0741C25.9583 37.6603 26.2377 37.08 26.2729 36.4606C26.308 35.8411 26.0961 35.2329 25.6835 34.7695L16.9062 24.9023C16.4928 24.4361 15.9112 24.1532 15.2892 24.1158C14.6673 24.0784 14.056 24.2897 13.5898 24.703C13.1236 25.1164 12.8407 25.698 12.8033 26.32C12.7659 26.9419 12.9772 27.5532 13.3905 28.0194L22.1796 37.8866C22.3847 38.1173 22.6333 38.3052 22.9112 38.4395C23.189 38.5738 23.4907 38.6519 23.7989 38.6693C24.107 38.6868 24.4156 38.6431 24.7068 38.541C24.998 38.4389 25.2662 38.2802 25.496 38.0741Z"
                                      fill="#2222E3"
                                  />
                                </svg>
                              </div>
                              <div style={{ fontSize: 12 }}>
                                <h4 style={{ fontWeight: 700 }}>Gamification</h4>
                                <p>Level: 1</p>
                                <p>Points: 0 points</p>
                                <p>Progress: 0%</p>
                                <img
                                    src="https://vxapp.wfsystems.com.ar/storage/logos/20231114001227.png"
                                    alt="Gamification Icon"
                                    style={styles.icon}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Device Information */}
                          <div style={styles.card}>
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "30%" }}>
                                <svg
                                    width={50}
                                    height={50}
                                    viewBox="0 0 139 143"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                      cx={63.5}
                                      cy={52}
                                      r={31}
                                      fill="#7BC7F5"
                                  />
                                  <path
                                      d="M44.375 10.0625H49.0625V14.75H44.375V10.0625Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M53.75 10.0625H72.5V14.75H53.75V10.0625Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M67.8125 94.4375H58.4375C56.5727 94.4375 54.7843 95.1783 53.4657 96.4969C52.147 97.8155 51.4063 99.6039 51.4062 101.469C51.4063 103.334 52.147 105.122 53.4657 106.441C54.7843 107.759 56.5727 108.5 58.4375 108.5H67.8125C69.6773 108.5 71.4657 107.759 72.7843 106.441C74.103 105.122 74.8438 103.334 74.8438 101.469C74.8438 99.6039 74.103 97.8155 72.7843 96.4969C71.4657 95.1783 69.6773 94.4375 67.8125 94.4375ZM67.8125 103.812H58.4375C57.8159 103.812 57.2198 103.566 56.7802 103.126C56.3407 102.686 56.0938 102.09 56.0938 101.469C56.0938 100.847 56.3407 100.251 56.7802 99.8115C57.2198 99.3719 57.8159 99.125 58.4375 99.125H67.8125C68.4341 99.125 69.0302 99.3719 69.4698 99.8115C69.9093 100.251 70.1562 100.847 70.1562 101.469C70.1562 102.09 69.9093 102.686 69.4698 103.126C69.0302 103.566 68.4341 103.812 67.8125 103.812Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M6.87505 61.625H11.5625V34.4703L14.593 37.5008L17.9071 34.1867L10.8758 27.1555C10.4363 26.7161 9.84028 26.4692 9.2188 26.4692C8.59732 26.4692 8.00129 26.7161 7.56177 27.1555L0.530518 34.1867L3.84458 37.5008L6.87505 34.4703V61.625Z"
                                      fill="#9F0DFF"
                                  />
                                  <path
                                      d="M114.688 34.4703V61.625H119.375V34.4703L122.406 37.5008L125.72 34.1867L118.688 27.1555C118.249 26.7161 117.653 26.4692 117.031 26.4692C116.41 26.4692 115.814 26.7161 115.374 27.1555L108.343 34.1867L111.657 37.5008L114.688 34.4703Z"
                                      fill="#9F0DFF"
                                  />
                                  <path
                                      d="M128.75 103.812C126.543 103.804 124.407 104.585 122.727 106.016C121.891 104.63 120.712 103.484 119.304 102.687C117.895 101.891 116.305 101.471 114.688 101.469C112.481 101.46 110.344 102.241 108.664 103.672C107.398 101.563 105.352 100.039 102.969 99.4297V17.0938C102.964 12.7441 101.234 8.57395 98.158 5.49826C95.0823 2.42257 90.9122 0.692463 86.5625 0.6875H39.6875C35.3378 0.692463 31.1677 2.42257 28.092 5.49826C25.0163 8.57395 23.2862 12.7441 23.2812 17.0938V59.9844C21.7913 60.6813 20.59 61.8743 19.8828 63.3594L9.24219 86.4453C7.69 89.828 6.88272 93.5047 6.875 97.2266V141.312H11.5625V97.2266C11.5704 94.1834 12.2339 91.1777 13.5078 88.4141L23.2812 67.2031V101.469C23.2845 103.381 23.6257 105.277 24.2891 107.07L21.9687 111.078L26.0234 113.422L40.0859 89.0703C40.3906 88.5347 40.7979 88.0644 41.2846 87.6864C41.7712 87.3084 42.3276 87.03 42.9219 86.8672C44.1255 86.5593 45.4014 86.7272 46.4844 87.3359C47.561 87.9624 48.3455 88.9899 48.6662 90.1935C48.9868 91.3971 48.8175 92.6788 48.1953 93.7578L37.6484 112.016C37.4447 112.382 37.3397 112.795 37.3438 113.214C37.3479 113.633 37.461 114.044 37.6719 114.406L42.6875 122.75C43.7868 124.567 44.3702 126.65 44.375 128.773V141.289H49.0625V128.773C49.0571 125.801 48.2472 122.885 46.7188 120.336L45.2422 117.875H59.7031C59.0654 120.281 59.4023 122.841 60.6406 125L70.7422 142.484L74.7969 140.141L64.6953 122.656C64.2255 121.853 64.0054 120.928 64.063 119.999C64.1207 119.07 64.4535 118.18 65.019 117.441C65.5846 116.702 66.3573 116.148 67.2388 115.85C68.1203 115.551 69.0706 115.522 69.9688 115.766C70.5662 115.921 71.1256 116.197 71.6132 116.576C72.1007 116.954 72.5061 117.428 72.8047 117.969L77.4922 126.078C77.7556 126.523 78.1559 126.871 78.6333 127.069C79.1106 127.268 79.6394 127.306 80.1406 127.18C80.64 127.045 81.081 126.749 81.3947 126.338C81.7084 125.927 81.8773 125.423 81.875 124.906V80.375C81.875 79.1318 82.3689 77.9395 83.2479 77.0604C84.127 76.1814 85.3193 75.6875 86.5625 75.6875C87.8057 75.6875 88.998 76.1814 89.8771 77.0604C90.7561 77.9395 91.25 79.1318 91.25 80.375V117.875C91.25 118.497 91.4969 119.093 91.9365 119.532C92.376 119.972 92.9721 120.219 93.5938 120.219C94.2154 120.219 94.8115 119.972 95.251 119.532C95.6906 119.093 95.9375 118.497 95.9375 117.875V108.5C95.9375 107.257 96.4314 106.065 97.3104 105.185C98.1895 104.306 99.3818 103.812 100.625 103.812C101.868 103.812 103.06 104.306 103.94 105.185C104.819 106.065 105.312 107.257 105.312 108.5V117.875C105.312 118.497 105.559 119.093 105.999 119.532C106.439 119.972 107.035 120.219 107.656 120.219C108.278 120.219 108.874 119.972 109.314 119.532C109.753 119.093 110 118.497 110 117.875V110.844C110 109.601 110.494 108.408 111.373 107.529C112.252 106.65 113.444 106.156 114.688 106.156C115.931 106.156 117.123 106.65 118.002 107.529C118.881 108.408 119.375 109.601 119.375 110.844V117.875C119.375 118.497 119.622 119.093 120.061 119.532C120.501 119.972 121.097 120.219 121.719 120.219C122.34 120.219 122.936 119.972 123.376 119.532C123.816 119.093 124.062 118.497 124.062 117.875V113.188C124.062 111.944 124.556 110.752 125.435 109.873C126.315 108.994 127.507 108.5 128.75 108.5C129.993 108.5 131.185 108.994 132.065 109.873C132.944 110.752 133.438 111.944 133.438 113.188V141.312H138.125V113.188C138.125 110.701 137.137 108.317 135.379 106.558C133.621 104.8 131.236 103.812 128.75 103.812ZM98.2812 99.4297C97.4599 99.6418 96.6713 99.9651 95.9375 100.391V80.375C95.9375 77.8886 94.9498 75.504 93.1916 73.7459C91.4335 71.9877 89.0489 71 86.5625 71C84.0761 71 81.6915 71.9877 79.9334 73.7459C78.1752 75.504 77.1875 77.8886 77.1875 80.375V113.188H74.8203C73.765 112.283 72.5253 111.619 71.1875 111.242C68.7816 110.606 66.2219 110.943 64.0625 112.18C63.5735 112.475 63.1108 112.812 62.6797 113.188H42.4297L42.4062 113.164L52.2734 96.1016C53.5166 93.9477 53.8533 91.3882 53.2094 88.9861C52.5655 86.5841 50.9937 84.5362 48.8398 83.293C46.686 82.0498 44.1265 81.7131 41.7244 82.357C39.3223 83.0009 37.2745 84.5727 36.0313 86.7266L27.9688 100.672V17.0938C27.9688 13.9857 29.2034 11.005 31.4011 8.80734C33.5988 6.60965 36.5795 5.375 39.6875 5.375H86.5625C89.6705 5.375 92.6512 6.60965 94.8489 8.80734C97.0466 11.005 98.2812 13.9857 98.2812 17.0938V99.4297Z"
                                      fill="#2222E3"
                                  />
                                  <path
                                      d="M60.7812 45.2188H65.4688C66.0904 45.2188 66.6865 45.4657 67.126 45.9052C67.5656 46.3448 67.8125 46.9409 67.8125 47.5625H72.5C72.5 45.6977 71.7592 43.9093 70.4406 42.5907C69.122 41.272 67.3336 40.5312 65.4688 40.5312V38.1875H60.7812V40.5312C58.9164 40.5312 57.128 41.272 55.8094 42.5907C54.4908 43.9093 53.75 45.6977 53.75 47.5625C53.75 49.4273 54.4908 51.2157 55.8094 52.5343C57.128 53.853 58.9164 54.5938 60.7812 54.5938H65.4688C66.0904 54.5938 66.6865 54.8407 67.126 55.2802C67.5656 55.7198 67.8125 56.3159 67.8125 56.9375C67.8125 57.5591 67.5656 58.1552 67.126 58.5948C66.6865 59.0343 66.0904 59.2812 65.4688 59.2812H60.7812C60.1596 59.2812 59.5635 59.0343 59.124 58.5948C58.6844 58.1552 58.4375 57.5591 58.4375 56.9375H53.75C53.75 58.8023 54.4908 60.5907 55.8094 61.9093C57.128 63.228 58.9164 63.9688 60.7812 63.9688V66.3125H65.4688V63.9688C67.3336 63.9688 69.122 63.228 70.4406 61.9093C71.7592 60.5907 72.5 58.8023 72.5 56.9375C72.5 55.0727 71.7592 53.2843 70.4406 51.9657C69.122 50.647 67.3336 49.9062 65.4688 49.9062H60.7812C60.1596 49.9062 59.5635 49.6593 59.124 49.2198C58.6844 48.7802 58.4375 48.1841 58.4375 47.5625C58.4375 46.9409 58.6844 46.3448 59.124 45.9052C59.5635 45.4657 60.1596 45.2188 60.7812 45.2188Z"
                                      fill={colors.primario}
                                  />
                                  <path
                                      d="M63.125 28.8125C58.4895 28.8125 53.9581 30.1871 50.1038 32.7624C46.2496 35.3378 43.2455 38.9982 41.4716 43.2809C39.6977 47.5635 39.2335 52.276 40.1379 56.8224C41.0422 61.3689 43.2744 65.545 46.5522 68.8228C49.83 72.1006 54.0062 74.3328 58.5526 75.2372C63.099 76.1415 67.8115 75.6774 72.0942 73.9034C76.3768 72.1295 80.0372 69.1255 82.6126 65.2712C85.1879 61.4169 86.5625 56.8855 86.5625 52.25C86.5557 46.0361 84.0842 40.0786 79.6903 35.6847C75.2964 31.2908 69.3389 28.8193 63.125 28.8125ZM63.125 71C59.4166 71 55.7915 69.9003 52.7081 67.8401C49.6247 65.7798 47.2214 62.8514 45.8023 59.4253C44.3831 55.9992 44.0118 52.2292 44.7353 48.5921C45.4588 44.9549 47.2445 41.614 49.8668 38.9917C52.489 36.3695 55.8299 34.5837 59.4671 33.8603C63.1042 33.1368 66.8742 33.5081 70.3003 34.9273C73.7264 36.3464 76.6548 38.7496 78.7151 41.8331C80.7753 44.9165 81.875 48.5416 81.875 52.25C81.8694 57.2211 79.8922 61.987 76.3771 65.5021C72.862 69.0172 68.0961 70.9944 63.125 71Z"
                                      fill={colors.primario}
                                  />
                                </svg>
                              </div>
                              <div style={{ fontSize: 12 }}>
                                <h4 style={{ fontWeight: 700 }}>
                                  Device Information
                                </h4>
                                <p>OS: ANDROID</p>
                                <p>Last Login: 2024-11-06 22:22:57</p>
                                <p>IP: 152.70.206.189</p>
                                <p>UUID: ...41d4-7f16-446655440000</p>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                      {/* Onboarding Timeline */}
                      <div style={{ ...styles.card, width: "50%" }}>
                        <h3 style={{ fontWeight: 700, marginBottom: 5 }}>
                          <strong>Onboarding Timeline</strong>
                        </h3>

                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ width: "30%" }}>
                            <svg
                                width={70}
                                height={159}
                                viewBox="0 0 151 159"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                  d="M76 59L50.3191 33.7743C47.8936 31.3919 47.8936 27.573 50.3191 25.2257L76 0L101.681 25.2257C104.106 27.6081 104.106 31.427 101.681 33.7743L76 59Z"
                                  fill="#9F0DFF"
                              />
                              <circle cx={75.5} cy={85} r={34} fill="#5ECAFA" />
                              <path
                                  d="M133.886 35.9092C133.682 34.9092 132.795 34.1819 131.773 34.1819C95.9545 34.1819 77.3181 13.3865 77.1363 13.1592C76.7045 12.6819 76.1136 12.4092 75.4999 12.4092C74.8636 12.4092 74.2727 12.6819 73.8636 13.1592C73.6818 13.3637 55.1818 34.1819 19.2499 34.1819C18.2272 34.1819 17.3408 34.9092 17.1363 35.9092C16.9545 36.7728 0.204482 122.705 74.6363 155.409C74.909 155.523 75.2045 155.591 75.4999 155.591C75.7954 155.591 76.0909 155.523 76.3636 155.409C150.818 122.682 134.068 36.7728 133.886 35.9092ZM75.4999 151.046C10.9545 122.023 19.1818 50.5001 21.0681 38.5001C52.0908 37.9092 70.1818 22.8637 75.4999 17.7046C80.8181 22.8865 98.9318 37.9092 129.954 38.5001C131.818 50.4774 140.091 122 75.4999 151.046Z"
                                  fill="#2222E3"
                              />
                              <path
                                  d="M122.477 44.5909C100.886 42.6136 85.7271 34.0909 76.818 27.3182C76.0453 26.7273 74.9771 26.7273 74.1816 27.3182C65.2725 34.1136 50.0907 42.6136 28.5226 44.5909C27.4771 44.6818 26.6589 45.5 26.568 46.5455C24.568 67.4773 25.2271 118.795 74.5225 143.386C74.818 143.545 75.1589 143.614 75.4998 143.614C75.8407 143.614 76.1589 143.545 76.4771 143.386C125.795 118.795 126.454 67.4773 124.454 46.5455C124.341 45.5 123.523 44.6818 122.477 44.5909ZM75.4998 139.023C30.8635 116.114 29.0453 69.6136 30.7271 48.7273C51.3635 46.4545 66.2498 38.5 75.4998 31.75C84.7498 38.5 99.6362 46.4773 120.273 48.7273C121.954 69.6136 120.136 116.114 75.4998 139.023Z"
                                  fill="#2222E3"
                              />
                              <path
                                  d="M75.5 59C61.1599 59 49.5 70.8841 49.5 85.5C49.5 100.116 61.1599 112 75.5 112C89.8401 112 101.5 100.116 101.5 85.5C101.5 70.8841 89.8401 59 75.5 59ZM75.5 108.191C63.2336 108.191 53.2366 98.0222 53.2366 85.5C53.2366 72.9778 63.2336 62.8085 75.5 62.8085C87.7664 62.8085 97.7634 72.9778 97.7634 85.5C97.7634 98.0222 87.7664 108.191 75.5 108.191Z"
                                  fill={colors.primario}
                              />
                              <path
                                  d="M84.4227 75.5557L70.3442 90.3742L66.5963 86.4293C65.8924 85.6884 64.7319 85.6884 64.0279 86.4293C63.324 87.1702 63.324 88.3917 64.0279 89.1327L69.0505 94.4393C69.393 94.7997 69.8496 95 70.3252 95C70.8008 95 71.2765 94.7997 71.5999 94.4393L86.9721 78.2591C87.676 77.5181 87.676 76.2966 86.9721 75.5557C86.2681 74.8148 85.1266 74.8148 84.4227 75.5557Z"
                                  fill={colors.primario}
                              />
                            </svg>
                          </div>
                          <div>
                            <table style={styles.timelineTable}>
                              <thead></thead>
                              <tbody>
                              {steps.map((step, index) => (
                                  <TimelineStep
                                      key={index}
                                      title={step.title}
                                      date={step.date}
                                  />
                              ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "300px",
                        justifySelf: "center",
                      }}
                  >
                    <h2>Accounts Content</h2>
                    <p>En construccion ...</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "300px",
                        justifySelf: "center",
                      }}
                  >
                    <h2>Scores Content</h2>
                    <p>En construccion ...</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "300px",
                        justifySelf: "center",
                      }}
                  >
                    <h2>Transactions Content</h2>
                    <p>En construccion ...</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "300px",
                        justifySelf: "center",
                      }}
                  >
                    <h2>Trades Content</h2>
                    <p>En construccion ...</p>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "300px",
                        justifySelf: "center",
                      }}
                  >
                    <h2>Digital Folder Content</h2>
                    <p>Contenido de Digital Folder...</p>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
        <div style={styles.base}></div>
      </div>
  );
};
